import httpFactory, { HttpType } from "../httpFactory";
export default {
    async isAvailable() {
        const http = httpFactory.getHttp(HttpType.Api);
        const response = await http.get("attachments/available");
        return response.data;
    }
};
